import { FC } from "react";
import { PriceTableSchema } from "src/utils/priceTable";
import { germanDateFormat } from "src/utils/helpers";
import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";
import { FormSchema } from "src/utils/formSchema";

type PriceTableProps = {
  priceTableInformation: PriceTableSchema[];
  form: UseFormReturn<FormSchema, unknown>;
};

const PriceTable: FC<PriceTableProps> = ({ priceTableInformation, form }) => {
  const { t } = useTranslation();

  const streetAndHouseNumber = form.watch("streetAndHouseNumber");

  const dateRange = form.watch("dateRange");

  return (
    <div className="table-container">
      <table id="invoice" align="left">
        <thead>
          <tr>
            <th>{t("charges:items")}</th>
            <th>{t("charges:numberOfDays")}</th>
            <th className="break-line">{t("charges:basePrice")}</th>
            <th className="break-line">{t("charges:total")}</th>
          </tr>
        </thead>
        <tbody>
          {priceTableInformation.map((priceRow, index) => {
            const {
              id,
              article,
              enabled,
              quantity,
              totalPrice,
              unitPrice,
              netPrice,
            } = priceRow;
            return enabled ? (
              <tr key={id}>
                <td data-label={t("charges:items")}>
                  <p>{article}</p>
                  {index === 0 && (
                    <>
                      <span className="street">{streetAndHouseNumber}</span>
                      {dateRange.from && dateRange.to ? (
                        <>
                          <span className="date-range">
                            {t("charges:from")}:&nbsp;
                            {germanDateFormat(dateRange.from)}
                            &nbsp;
                            {t("charges:to")}:&nbsp;
                            {germanDateFormat(dateRange.to)}
                          </span>
                        </>
                      ) : null}
                    </>
                  )}
                </td>
                <td data-label={t("charges:numberOfDays")}>
                  <strong>{quantity ? quantity : "-"}</strong>
                </td>
                <td data-label={t("charges:basePrice")}>
                  {unitPrice ? `${unitPrice.toFixed(2)}€` : "-"}
                </td>
                <td data-label={t("charges:total")}>
                  {netPrice ? (
                    <>
                      <p className="total-price">{totalPrice.toFixed(2)}€</p>(
                      {netPrice}€ netto)
                    </>
                  ) : (
                    `${totalPrice.toFixed(2)}€`
                  )}
                </td>
              </tr>
            ) : null;
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PriceTable;
